import Container from './HybridActivityMap';
export default Container;

export const componentName = 'HybridActivityMap';
